import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { ThemeContext } from '../context/ThemeContext';

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <header className={`h-16 border-b flex items-center justify-between px-6 z-10 ${theme === 'dark' ? 'bg-[#151D30] border-gray-800' : 'bg-white border-gray-200'}`}>
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded-lg bg-gradient-to-tr from-accentBlue to-accentViolet flex items-center justify-center text-white font-bold text-lg shadow-md">
          V
        </div>
        <span className="font-bold text-xl tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-purple-500">
          VibeChat
        </span>
      </div>

      <div className="flex items-center gap-4">
        <button 
          onClick={toggleTheme} 
          className={`p-2 rounded-full transition-colors ${theme === 'dark' ? 'hover:bg-gray-800 text-yellow-400' : 'hover:bg-gray-100 text-gray-600'}`}
          title="Toggle UI Theme"
        >
          {theme === 'dark' ? (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m9-9h-1M4 9H3m15.364-6.364l-.707.707M6.343 17.657l-.707.707M16.243 17.657l.707.707M6.343 6.343l.707-.707m2.828 9.9a5 5 0 117.072 0 5 5 0 01-7.072 0z" /></svg>
          ) : (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" /></svg>
          )}
        </button>

        {user && (
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full flex items-center justify-center font-bold text-white text-sm uppercase" style={{ backgroundColor: user.avatar.startsWith('#') ? user.avatar : '#3B82F6' }}>
                {!user.avatar.startsWith('#') ? <img src={user.avatar} alt="avatar" className="w-full h-full rounded-full object-cover" /> : user.username.charAt(0)}
              </div>
              <span className="hidden sm:inline font-medium text-sm">{user.username}</span>
            </div>
            <button 
              onClick={logout} 
              className="text-xs font-semibold px-3 py-1.5 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors shadow-sm"
            >
              Sign Out
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;